import { ConfirmPromotionSaleModal } from './ConfirmPromotionSaleModal'
import { withConfirmPromotionSaleModal } from './withConfirmPromotionSaleModal'

const ConnectedConfirmPromotionSaleModal = withConfirmPromotionSaleModal(
  ConfirmPromotionSaleModal
)
export { ConnectedConfirmPromotionSaleModal as ConfirmPromotionSaleModal }
